
import { Button, Modal } from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { putAccessControlDetails } from "../../../Service/AllAccessControlAPI";
import swal from "sweetalert";
import { useFormik } from "formik";

export default function AccessControlModal({ status, handleClose, rowData }) {

// all module
  const tags = [
    "Dashboard",
   
     "mainqoute",

// "funnel",

// "task",

  ];

//Function declaration of workorder module
  const subqouteTags = [
    // { value: "configurator", label: "Configurator" },
    // // { value: "approved", label: "Approved" },
    {value: "salesComponent", label: "PI Component List "},
    // { value: "underApproval", label: "Under Approval" },
    { value: "draft", label: "Quote Status" },   
  ];
//Function declaration of Service Engineer module


  //Update module
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      tags: rowData && rowData.moduleName !== [""] ? rowData.moduleName : [],
    },
    onSubmit: async (values) => {
      try {
        const token = sessionStorage.getItem("token");
        const headers = { Authorization: `Bearer ${token}` };
        var newRowData = JSON.parse(JSON.stringify(rowData));
        newRowData.moduleName = values.tags;
        delete newRowData["srno"];
        console.log("Access Control Data", newRowData);
        await putAccessControlDetails(newRowData, headers)
        .then((result) => {
          console.log("Access Control Data Result", result);
          swal( "Great", "Access control details added successfully", "success" );
          window.location.reload();
          handleClose();
        })
        .catch((error) => {
          console.log("Access Control Data Error", error);
          swal( "Failed", "Something went wrong please check your internet", "error" );
        });
      } catch (error) {
        console.log(error);
        swal( "Failed", "Something went wrong please check your internet", "error" );
      }
    },
  });

  const handleChange = (e) => {
    const { checked, name } = e.target;
    if (checked) {
      formik.setFieldValue("tags", [...formik.values.tags, name]);
    } else {
      formik.setFieldValue( "tags", formik.values.tags.filter((v) => v !== name) );
    }
  };

  return (
    <Modal show={status} onHide={handleClose}>
      <form onSubmit={formik.handleSubmit}>
        <Modal.Header closeButton>
          <Modal.Title>Access Control for RND User</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <>
            {tags.map((tag) => (
              <div key={tag}>
                <input
                  id={tag}
                  type="checkbox"
                  name={tag}
                  checked={formik.values.tags.includes(tag)}
                  onChange={handleChange}
                />{" "}
                <label htmlFor={tag}>{tag}</label>
              </div>
            ))}

            {formik.values.tags.includes("mainqoute") ? (
              <div>
              Qoute: <br />
                {subqouteTags.map((tag) => (
                  <div key={tag}>
                    <input
                      id={tag.value}
                      type="checkbox"
                      name={tag.value}
                      checked={formik.values.tags.includes(tag.value)}
                      onChange={handleChange}
                    />{" "}
                    <label htmlFor={tag.value} className="me-1">
                      {tag.label}
                    </label>
                  </div>
                ))}
              </div>
            ) : (
              ""
            )}

           
          </>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" type="submit">
            Submit
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}

